import { sorceryImageUrl } from '../cardImageUrl';

// URL builder for custom-art token images. The server's cosmetics
// catalog drives both the slug (stable identifier for the entitlement)
// and the version (cache-busting tag bumped on every art re-upload).
//
// Why the query string instead of a versioned slug like
// `custom-token-stealth-v2`? Because the slug doubles as the cosmetic
// ownership id (`player_cosmetics.cosmetic_id`). Changing the slug would
// either orphan players' existing entitlements or require a migration.
// A query-string version keeps the entitlement id stable while letting
// the URL fingerprint change. Electron's HTTP cache and the server's
// persistent disk cache both key on the full URL including query, so
// the bump forces a refetch without touching the ownership table.
export function buildTokenImageUrl(pack, origin = '') {
  if (!pack?.tokenSlug) return null;
  const base = sorceryImageUrl(pack.tokenSlug, origin);
  return pack.tokenVersion ? `${base}?v=${pack.tokenVersion}` : base;
}
